// extracted by mini-css-extract-plugin
export default {"container":"details_container__3rSs2","detailContainer":"details_detailContainer__F8B+2","img":"details_img__E5re6","el2":"details_el2__pdTsS","el3":"details_el3__l2amy"};